import { toKeyValueString } from 'modules/common/util/ObjectUtil';

const POPUP_WIDTH = 800;
const POPUP_HEIGHT = 500;
const NO = 'no';

const PopupConfig = {
  scrollbars: NO,
  toolbar: NO,
  location: NO,
  titlebar: NO,
  directories: NO,
  status: NO,
  menubar: NO,
  width: POPUP_WIDTH,
  height: POPUP_HEIGHT,
  top: (window.screenTop || window.screenY) + window.innerHeight / 2 - POPUP_HEIGHT / 2,
  left: (window.screenLeft || window.screenX) + window.innerWidth / 2 - POPUP_WIDTH / 2,
};

export default function createPopup(url: string, name: string) {
  return window.open(url, name, `${toKeyValueString(PopupConfig)}`);
}
